import React from "react";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { moneyFormat } from "./format";
import { getTeam, pickPercent } from "./utils";
import Auth from "routes/Auth";

const MarketingAwareness = ({
  competitiveAnalysis,
  teamId,
  incomeStatement,
  teams,
  competitionMetrics
}) => {
  const data =
    Auth.getPosition() === "Student" ? competitiveAnalysis : competitionMetrics;
  const team = getTeam(teamId, data);

  return (
    <OnePanelChart
      title="Awareness"
      chartTitle="PRODUCT AWARENESS"
      vertical
      suffix="%"
      data={pickPercent(teams, data, "Product Awareness")}
      teams={teams}
    >
      <Text>
        Your team spent {moneyFormat(-incomeStatement["Promotion Costs"])} in
        marketing to drive overall product awareness to{" "}
        {(team["Product Awareness"] * 100).toFixed(2)}%.
      </Text>
    </OnePanelChart>
  );
};

export default MarketingAwareness;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingAwareness.js